import { textToChecklistValue } from "@smartsuite/fields-logic/lib/clipboard";
import type { ChecklistFieldValue } from "@smartsuite/types";
import type { FieldRegistryConfig } from "../../types";
import { checklistToReviewString } from "../review/reviewString.helpers";
import { ChecklistFieldControl } from "./ChecklistFieldControl/ChecklistFieldControl";
import { ChecklistReviewValue } from "./ChecklistReviewValue/ChecklistReviewValue";
import { normalizeChecklistDefaultValue } from "./normalizeDefault";

/** Multiple manual values are separated with ";" across the platform's default-value inputs. */
const PREFILL_ITEM_SEPARATOR = ";";

/**
 * The form value is already a valid `ChecklistFieldValue` (the react-ui ChecklistField
 * maintains items + counts), so no `convertFormValueToApi` is needed.
 */
export const checklistFieldConfig: FieldRegistryConfig<ChecklistFieldValue> = {
  icon: "checklist",
  control: ChecklistFieldControl,
  // A URL prefill arrives as plain text. Each entry is converted with the same text ->
  // checklist converter the grid uses for pasted text, which builds the smartdoc
  // `content.data`/`content.html` pair and a uuid id per item.
  prefill: ({ value }) =>
    normalizeChecklistDefaultValue(
      value
        .split(PREFILL_ITEM_SEPARATOR)
        .map((entry) => entry.trim())
        .filter(Boolean)
        .flatMap((entry) => textToChecklistValue(entry).items ?? []),
    ),
  // `toReviewString` still decides answered vs "Unanswered" on the review page; when there is
  // something to show, `reviewControl` renders it as a row per item instead of that one line.
  toReviewString: checklistToReviewString,
  reviewControl: ChecklistReviewValue,
};
